import { IconButton, TableCell, TableRow } from '@mui/material';
import { useTranslation } from 'react-i18next';
import EditIcon from '@mui/icons-material/Edit';
import { DateTime } from 'luxon';
import { BillingItem, BillingItemType } from '../../../model/BillingItem';
import {
  getBillingItemProratedPrice,
  getBillingItemQuantity,
  getBillingItemTitle,
} from '../../../utils/billingItem';
import { useAuth } from '../../../stores';

const InvoiceRow = ({
  billingItem,
  handleEditBillingItem,
  month,
}: {
  billingItem: BillingItem;
  handleEditBillingItem: (item: BillingItem) => void;
  month: string;
}) => {
  const auth = useAuth();
  const { t } = useTranslation();

  const getStartDate = () => {
    if (billingItem.type === BillingItemType.ONE_TIME) {
      return DateTime.fromISO(billingItem.datePaid).toFormat('yyyy-MM-dd');
    }
    if (billingItem.type === BillingItemType.USAGE) {
      return billingItem.period;
    }
    let { startDate } = billingItem;
    if (billingItem.paidUntil) {
      startDate = DateTime.fromISO(billingItem.paidUntil).plus({ days: 1 }).toFormat('yyyy-MM-dd');
    }
    return startDate ? DateTime.fromISO(startDate).toFormat('yyyy-MM-dd') : '';
  };

  const getEndDate = () => {
    if (billingItem.type === BillingItemType.ONE_TIME) {
      return '';
    }
    if (billingItem.type === BillingItemType.USAGE) {
      return '';
    }
    // return max of startDate and end of month
    const endOfMonth = DateTime.fromFormat(month, 'yyyy-MM').plus({ months: 1 }).endOf('month');
    const endDate = billingItem.endDate ? DateTime.fromISO(billingItem.endDate) : endOfMonth;
    return endDate > endOfMonth
      ? endOfMonth.toFormat('yyyy-MM-dd')
      : endDate.toFormat('yyyy-MM-dd');
  };
  return (
    <TableRow key={`billing-item-${billingItem.type}-${billingItem.id || 'no-id'}`}>
      <TableCell>{getBillingItemTitle(billingItem, t)}</TableCell>
      <TableCell>{getStartDate()}</TableCell>
      <TableCell>{getEndDate()}</TableCell>
      <TableCell align="right">{getBillingItemQuantity(billingItem, month) || '-'}</TableCell>
      <TableCell align="right">
        {billingItem.isDemo
          ? 'Demo'
          : billingItem.unitPrice.applyPercentageDiscount(billingItem.discount).format()}
      </TableCell>
      <TableCell align="right">
        {getBillingItemProratedPrice(billingItem, month).format()}
      </TableCell>
      {auth.isAdmin && (
        <TableCell align="center">
          <IconButton size="small" onClick={() => handleEditBillingItem(billingItem)}>
            <EditIcon />
          </IconButton>
        </TableCell>
      )}
    </TableRow>
  );
};

export default InvoiceRow;
